"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Terms() {
  const content = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="1888" id="smstermsconditions" className="relative bg-background text-foreground py-28 md:py-36 overflow-hidden">
      <div ref={content.ref} className={`relative mx-auto max-w-[880px] px-5 md:px-8 transition-all duration-700 ease-out ${content.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <div className="prose prose-slate dark:prose-invert max-w-none">
          <h1 className="font-serif font-semibold text-[clamp(2.25rem,4.4vw,4rem)] leading-[1.02] tracking-tight mb-12 text-center">
            SMS Terms of <span className="italic text-[var(--primary)]">Service</span>
          </h1>

          <div className="space-y-8 font-default text-[clamp(1.0625rem,1.25vw,1.25rem)] leading-[1.6] text-muted-foreground">
            <section>
              <h2 className="font-serif text-2xl text-foreground mb-4">1. Program Description</h2>
              <p>
                LeavingIL.com offers mobile alerts to users interested in real estate relocation services and exit strategies. These messages may include updates on property evaluations, relocation timelines, and service notifications related to your move out of Illinois.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-foreground mb-4">2. Message Frequency</h2>
              <p>
                Message frequency varies based on user interaction and the stage of your relocation process. You can expect to receive updates as milestones in your exit plan are reached.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-foreground mb-4">3. Opt-Out & Support</h2>
              <p>
                You can cancel the SMS service at any time. To unsubscribe, reply STOP to any text message you receive from us. After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.
              </p>
              <p className="mt-4">
                If you are experiencing issues with the messaging program you can reply with the keyword <strong>HELP</strong> for more assistance, or you can get help directly at{" "}
                <Link to="mailto:ed@leavingil.com" className="text-[var(--primary)] hover:underline">
                  ed@leavingil.com
                </Link>{" "}
                or call{" "}
                <Link to="tel:224-800-6979" className="text-[var(--primary)] hover:underline">
                  224-800-6979
                </Link>.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-foreground mb-4">4. Interruption & Liability</h2>
              <p>
                Carriers are not liable for delayed or undelivered messages. As always, message and data rates may apply for any messages sent to you from us and to us from you. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-foreground mb-4">5. Privacy</h2>
              <p>
                We value your privacy. For all questions about the data we collect and how we use it, please read our{" "}
                <Link to="/PrivacyPolicyPage" className="text-[var(--primary)] hover:underline font-medium">
                  Privacy Policy
                </Link>.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-foreground mb-4">6. Age Requirement (18+)</h2>
              <p>
                You must be at least 18 years old to participate in our SMS program. By opting in, you confirm that you are at least 18 years old and authorized to receive text messages at the phone number provided.
              </p>
            </section>
          </div>
        </div>
      </div>
    </section>;
}